import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import config from "emun.invoice/invoice.config";
import cartConfig from "emun.cart/cart.config";

import emailInvoicePrompt from "emun.invoice/email-invoice-prompt";
import creditMemoPrompt from "emun.invoice/credit-memo-prompt";
import PrintInvoiceOptions from "emun.invoice/invoice-print";
import ServiceBus from "servicestack/service-bus";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";

//import CartItem from "emun.cart/cart-item.model";

export default class InvoiceListController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = config;
		$ctrl.cartConfig = cartConfig;
		$ctrl.creditRequestConfig = creditRequestConfig;
		$ctrl.bus = new ServiceBus();
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.query = new AutoQuery($ctrl.getQueryOptions());
	}

	getQueryOptions() {
		const $ctrl = this;
		var url = "QueryInvoices.json";
		var filters = [];
		if ($ctrl.customer && $ctrl.customer.id) {
			url = url + `?retailerId=${$ctrl.customer.id}`;
		}
		
		return {
			url: url,
			fields: $ctrl.config.invoiceFields,
			orderBy: "-InvoiceDate,Id",
			pageSize: 12,
			criteria: {
				orderNumber: $ctrl.orderId,
				[$ctrl.customerId ? "retailerId" : "IGNORE"]: $ctrl.customerId,
				customerPORef: $ctrl.invoiceId,
				//retailerId: $ctrl.customerId && $ctrl.customerId !== "undefined" && $ctrl.customerId !== undefined && $ctrl.customerId !== null ? $ctrl.customerId : undefined
			},
			views: {
				list: "th-list",
				cards: "th",
			},
			view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
			//view: "cards",
			filters: [
				{ groupBy: "ShippingLocationAddress", title: "Ship Address" },
				{ groupBy: "Status" },
				{ text: "LineProductId", title: "Product #" },
				{ date: "InvoiceDate", title: "Invoice Date" },
				{
					groupBy: "SalesRepID",
					title: "Rep # of Record",
					roles: ["Administrator", "Sales Manager", "Web Admin", "Corporate"],
				},
				{ groupBy: "TransactionType", title: "Document Type" },
			],
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			autoLoad: true,
			sortOptions: {
				Id: "Invoice No: Low to High",
				"-Id": "Invoice No: High to Low",
				"Status,-Id": "Status: A to Z",
				"-Status,-Id": "Status: Z to A",
				"InvoiceDate,-Id": "Invoice Date: Newest",
				"-InvoiceDate,-Id": "Invoice Date: Oldest",
				"InvoiceTotal,-Id": "Amount: Low to High",
				"-InvoiceTotal,-Id": "Amount: High to Low",
			},
		};
	}
	load() {
		const $ctrl = this;
		return this.query.load.apply(this.query, arguments);
	}
	printInvoice(invoice) {
		const $ctrl = this;
		return PrintInvoiceOptions({
			request: {
				id: invoice,
				IncludeImages: false,
				IncludeBarcodes: false,
				OrderBy: "strProductID",
			},
		});
	}
	//printInvoice(invoice) {
	//    let $ctrl = this;
	//    var url = $appConfig.serviceUrl + "PrintInvoice/" + invoice;
	//    return location.href = url;
	//}
	credit(invoiceId) {
		const $ctrl = this;
		const creditMemo = {
			invoiceId: invoiceId,
			status: $ctrl.creditRequestConfig.creditRequestDefaultStatus || "Open",
		};

		$ctrl.bus
			.send("CreateCreditMemoRequest.json?jsconfig=ua,uaa", creditMemo)
			.then(
				(res) => $ctrl.onCreditMemoCreated(res.data)),
				(res) => {
					if (res.data.responseStatus.errorCode == "CreditMemoRequestExists") {
					  modals
						.confirm(
						  "A credit request already exists for this invoice.  Would you like to open it?"
						)
						.result.then(function () {
						  return $ctrl.$state.transitionTo("retailer.credit-request.detail", {
							retailerId: $ctrl.customer.id,
							creditRequestId: res.data.responseStatus.errors[0].fieldName,
						  });
						});
					}
				  }
				  //   const $ctrl = this;
		//   return creditMemoPrompt({
		//     retailerId: $ctrl.retailerId,
		//     model: {
		//       invoiceId,
		//       status: "Open"
		//     }
		//}).then(res => $ctrl.onCreditMemoCreated(res.data));
	}
	onCreditMemoCreated(creditMemo) {
		const $ctrl = this;
		return $ctrl.$state.transitionTo("retailer.creditmemo", {
			retailerId: $ctrl.retailerId,
			id: creditMemo.id,
		});
	}
	requestReturn(invoiceId) {
		return this.credit(invoiceId);
	}
	makePayment(invoice) {
		const $ctrl = this;
		$ctrl.$state.transitionTo("retailer.payments", {
			retailerId: $ctrl.retailerId,
			invoice,
		});
	}
	emailInvoice(invoice) {
		//emailInvoicePrompt(options);
		const $ctrl = this;
		return emailInvoicePrompt({
			id: invoice,
			invoiceNumber: invoice,
			IncludeImages: false,
			IncludeBarcodes: false,
			OrderBy: "strProductID",
		});
	}
	return(invoice) {
		const $ctrl = this;
		if (
			$ctrl.creditRequestConfig.invoiceAgeLimit && $ctrl.creditRequestConfig.invoiceAgeLimit > -1 &&
		  moment(invoice.invoiceDate).isBefore(
			moment().subtract($ctrl.creditRequestConfig.invoiceAgeLimit, "day")
		  )
		) {
		  const returnActions = {
			"Contact Customer Service": {
			  icon: "envelope",
			  body: "Contact Customer Service",
			  handler: () => {
				formSubmissionPrompt(
				  Object.assign({
					title: "Contact Us by Email",
					formioId: "Contact Us",
				  })
				);
			  },
			},
			Cancel: {
			  icon: "close",
			  body: "Cancel claim request",
			  handler: () => false,
			},
		  };
		  return actionList({
			title: `Claim Request`,
			body: `This invoice is more than ${$ctrl.creditRequestConfig.invoiceAgeLimit} days old.  To submit a claim please contact customer service for review`,
			actions: returnActions,
			size: "md",
		  }).then((a) => a.handler());
		} else {
		  $ctrl.$state.transitionTo("inv.request-credit", {
			retailerId: invoice.retailerId,
			orderId: invoice.orderNumber,
			invoiceId: invoice.invoiceNumber,
		  });
		}
	  }
	statusCss(status) {
		switch ((status || "").replace(/\W/gi, "").toLowerCase()) {
			case "cart":
				return "label-warning";
			case "inprogress":
			case "open":
				return "label-success";
			case "complete":
				return "bg-color-1";
			case "cancel":
			case "cancelled":
			case "deleted":
				return "label-danger";
			case "shipped":
				return "bg-color-4";
		}
		return "label-default";
	}
}
